import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { CardContent } from "@mui/material";
import Card from "../../components/Cards/Card";
import { useSelections } from "../../context/Selections";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import GestaoDaInfoSVG from "../../assets/icons/gestaodainfo.svg";
import GestaoDePessoasSVG from "../../assets/icons/gestaodepessoas.svg";
import GestaoDQBSVG from "../../assets/icons/gestaodqbs.svg";
import GestaoExecucaoSVG from "../../assets/icons/gestaoexecucao.svg";
import GestaoPlanejamentoSVG from "../../assets/icons/gestaoplanejamento.svg";
import GestaoVendasSVG from "../../assets/icons/gestaovendas.svg";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 10px;
`;

function OverviewDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = React.useState("Execucao");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (app) {
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Grupo Distribuição")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutCardsWrapper>
          <p className="container-titles">
                <span>Período Fechamento :</span>

                <NativeObject
                  app={app}
                  key="SbbnKHE"
                  reference={{ id: "SbbnKHE" }}
                  className="container-object"
                  style={{ width: '70px'}}
                />

          </p>
          <LayoutCardWrapper>
            {singleGroupView ? (
              <div className="single-view">
                <div id="kpis" className="row-kpis">
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Gestão de Planejamento",
                    }}
                    style={{
                      width: "100%",
                      paddingRight: "70px",
                      position: "relative",
                    }}
                  >
                    <div className="container-items">
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="GgYznz"
                        reference={{
                          id: "GgYznz",
                        }}
                      />

                      <div className="container-img">
                        <img
                          src={GestaoPlanejamentoSVG}
                          alt="icon"
                          width={55}
                        />
                      </div>
                    </div>
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: "Gestão de Vendas",
                    }}
                    style={{
                      width: "100%",
                      paddingRight: "70px",
                      position: "relative",
                    }}
                  >
                    <div className="container-items">
                      <div
                        style={{
                          paddingLeft: "15px",
                        }}
                      >
                        <NativeObject
                          className="kpiValueBold"
                          app={app}
                          key="JhXMYb"
                          reference={{ id: "JhXMYb" }}
                        />
                      </div>

                      <div className="container-img">
                        <img src={GestaoVendasSVG} alt="icon" width={55} />
                      </div>
                    </div>
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: "Gestão de Execução",
                    }}
                    style={{
                      width: "100%",
                      paddingRight: "70px",
                      position: "relative",
                    }}
                    classStyle={"row-header"}
                  >
                    <div className="container-items">
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="GCFSmF"
                        reference={{ id: "GCFSmF" }}
                      />

                      <div className="container-img">
                        <img src={GestaoExecucaoSVG} alt="icon" width={55} />
                      </div>
                    </div>
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: "Gestão de Clientes DQBs",
                    }}
                    style={{
                      width: "100%",
                      paddingRight: "70px",
                      position: "relative",
                    }}
                    classStyle={"row-header"}
                  >
                    <div className="container-items">
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="MvRYT"
                        reference={{ id: "MvRYT" }}
                      />

                      <div className="container-img">
                        <img src={GestaoDQBSVG} alt="icon" width={55} />
                      </div>
                    </div>
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: "Gestão da Informação",
                    }}
                    style={{
                      width: "100%",
                      paddingRight: "70px",
                      position: "relative",
                    }}
                    classStyle={"row-header"}
                  >
                    <div className="container-items">
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="NRvPSC"
                        reference={{ id: "NRvPSC" }}
                      />

                      <div className="container-img">
                        <img src={GestaoDaInfoSVG} alt="icon" width={55} />
                      </div>
                    </div>
                  </Card>

                  <Card
                    app={app}
                    header={{
                      hardTitle: "Gestão de Pessoas",
                    }}
                    style={{
                      width: "100%",
                      paddingRight: "70px",
                      position: "relative",
                    }}
                    classStyle={"row-header"}
                  >
                    <div className="container-items">
                      <NativeObject
                        className="kpiValueBold"
                        app={app}
                        key="ApERJA"
                        reference={{ id: "ApERJA" }}
                      />

                      <div className="container-img">
                        <img src={GestaoDePessoasSVG} alt="icon" width={55} />
                      </div>
                    </div>
                  </Card>
                </div>

                <div id="distinfos" className="row-info">
                  <Card
                    app={app}
                    style={{
                      width: "34%",
                      height: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        height: "20%",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        paddingLeft: "20px",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        Distribuidor:{" "}
                      </span>

                      <NativeObject
                        app={app}
                        key="NkMuVE"
                        reference={{
                          id: "NkMuVE",
                        }}
                        style={{ paddingTop: "6px" }}
                      />
                    </div>

                    <NativeObject
                      className="elegibleCard"
                      app={app}
                      key="QHjkECZ"
                      reference={{
                        id: "QHjkECZ",
                      }}
                      style={{
                        height: "50%",
                        padding: "10px",
                        borderRadius: "16px",
                      }}
                    />

                    <NativeObject
                      className="elegibleCard"
                      app={app}
                      key="GGDPEjk"
                      reference={{
                        id: "GGDPEjk",
                      }}
                      style={{
                        height: "50%",
                        padding: "10px",
                        borderRadius: "16px",
                      }}
                    />
                  </Card>

                  <Card
                    app={app}
                    style={{
                      width: "70%",
                      height: "100%",
                    }}
                    classStyle={"row-header"}
                  >
                    <NativeObject
                      app={app}
                      key="damFq"
                      reference={{
                        id: "damFq",
                      }}
                      style={{
                        width: "100%",
                        height: "50%",
                      }}
                    />
                    <NativeObject
                      app={app}
                      key="CmBqTT"
                      reference={{
                        id: "CmBqTT",
                      }}
                      style={{
                        width: "100%",
                        height: "50%",
                      }}
                    />
                  </Card>
                </div>

                <Card
                  app={app}
                  exportTable
                  exportContainer
                  exportTableId="cJHrAeM"
                  header={{
                    hardTitle: "Detalhamento",
                  }}
                  style={{ width: "100%" }}
                  className={"container-table"}
                >
                  <NativeObject
                    app={app}
                    key="cJHrAeM"
                    reference={{ id: "cJHrAeM" }}
                  />
                </Card>
              </div>
            ) : (
              <>
                <Card
                  app={app}
                  exportTable
                  exportContainer
                  exportTableId="VmCgPd"
                  header={{
                    hardTitle: "Rankings",
                  }}
                  style={{ width: "100%" }}
                  className={"container-table"}
                >
                  <CardContent className="align-tables">
                    <div className="side-tables-one">
                      <Card
                        app={app}
                        header={{
                          hardTitle: "Cluster Diamante",
                        }}
                        style={{ width: "100%" }}
                        className={"cluster-diamante"}
                      >
                        <NativeObject
                          app={app}
                          key="DjwYBW"
                          reference={{ id: "DjwYBW" }}
                          style={{ padding: 16 }}
                        />
                      </Card>

                      <Card
                        app={app}
                        header={{
                          hardTitle: "Cluster Ouro",
                        }}
                        style={{ width: "100%" }}
                        className={"cluster-ouro"}
                      >
                        <NativeObject
                          app={app}
                          key="DXcvXWU"
                          reference={{ id: "DXcvXWU" }}
                          style={{ padding: 16 }}
                        />
                      </Card>

                      <Card
                        app={app}
                        header={{
                          hardTitle: "Cluster Prata",
                        }}
                        style={{ width: "100%" }}
                        className={"cluster-prata"}
                      >
                        <NativeObject
                          app={app}
                          key="GfypjT"
                          reference={{ id: "GfypjT" }}
                          style={{ padding: 16 }}
                        />
                      </Card>

                      <Card
                        app={app}
                        header={{
                          hardTitle: "Cluster Pré-PED",
                        }}
                        style={{ width: "100%" }}
                        className={"cluster-pre-ped"}
                      >
                        <NativeObject
                          app={app}
                          key="bvAGp"
                          reference={{ id: "bvAGp" }}
                          style={{ padding: 16 }}
                        />
                      </Card>
                    </div>

                    <div className="side-tables-two">
                      <div className="side-tables-two-row">
                        <NativeObject
                          app={app}
                          key="VmCgPd"
                          reference={{ id: "VmCgPd" }}
                          style={{ borderRadius: "6px", width: "100%", height: "100%" }}
                        />
                      </div>
                      <div className="side-tables-two-column">
                        <div className="chart-container">
                          <NativeObject
                            app={app}
                            key="pXMqE"
                            reference={{ id: "pXMqE" }}
                            style={{ borderRadius: "6px", width: "100%", height: "100%" }}
                          />
                        </div>
                        <div className="chart-container text-container">
                          <span className="info-text">
                            Participantes do Pré-PED acompanham o programa para
                            avaliação de ingresso futuro. Portanto, não fazem
                            parte do Programa de Excelência e não estão
                            elegíveis à premiação.
                          </span>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </>
            )}
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

OverviewDesktop.defaultProps = {
  app: null,
  config: {},
};

OverviewDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OverviewDesktop;
